import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { imageResizerService } from '../domain/services/imageResizerService';
import { SmartLink } from './SmartLink/SmartLink';
import { ImageSimple } from './Image/ImageSimple';

const styles = {
  container: css`
    display: inline-block;
    height: 40px;
    img {
      display: inline-block;
      height: 40px;
      margin: 0;
      padding: 0;
    }
  `
};

export const SponsoredImage = ({ content }) => {
  if (content.sponsoredLogo?.entity?.mediaImage) {
    const imageWidth = imageResizerService.getWidth(
      content.sponsoredLogo.entity.mediaImage,
      40
    );

    if (content.sponsoredClickThrough?.url?.path) {
      return (
        <div css={styles.container}>
          <SmartLink
            to={content.sponsoredClickThrough.url.path}
            rel="sponsored"
          >
            <ImageSimple
              src={imageResizerService.getStyleUrl(
                content.sponsoredLogo.entity.mediaImage.url,
                null,
                40,
                {
                  position: content.sponsoredLogo.entity.focalPoint
                }
              )}
              width={imageWidth}
              height={40}
              alt={content.sponsoredLogo.entity.caption}
            />
          </SmartLink>
        </div>
      );
    }

    return (
      <div css={styles.container}>
        <ImageSimple
          src={imageResizerService.getStyleUrl(
            content.sponsoredLogo.entity.mediaImage.url,
            null,
            40,
            {
              position: content.sponsoredLogo.entity.focalPoint
            }
          )}
          width={imageWidth}
          height={40}
          alt={content.sponsoredLogo.entity.caption}
        />
      </div>
    );
  }
  return null;
};

SponsoredImage.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired
};
